// Sticky bottom slot. The Composer owns its own input state, keyboard
// handling (Enter / Shift+Enter), AND its own disclaimer line — Footer is
// just the layout shell.
//
// Centers the composer in a max-width column so the input doesn't stretch
// edge-to-edge on wide inline layouts, while the outer container still
// spans the full width.

import { Box } from '@chakra-ui/react';
import { Composer } from '../../../components/composer';

interface FooterProps {
  /** Fired with the trimmed submitted text and any attached files. */
  onSubmit: (_text: string, _files?: File[]) => void;
  /**
   * Max width for the inner composer column. Defaults to `100%` so the
   * floating overlay layout fills its narrow card; set to something like
   * `720px` for the wide inline layout.
   */
  contentMaxWidth?: string;
  /** Locks the composer while the previous turn is still resolving. */
  isAwaiting?: boolean;
  /** Bottom padding — the wide inline layout clears the docked bar; the
   *  floating widget doesn't need the extra gap. */
  bottomPad?: string;
}

export const Footer = ({
  onSubmit,
  contentMaxWidth = '100%',
  isAwaiting = false,
  bottomPad = '45px',
}: FooterProps) => (
  <Box as="footer" flexShrink={0} px="16px" py="12px" pb={bottomPad}>
    <Box maxW={contentMaxWidth} mx="auto">
      {/* `autoFocus` is mount-only — fires once per ThreadContainer
          mount so opening a thread (or switching sessions, which
          remounts via the `key={sessionId}` on the outer Flex) lands
          the caret in the composer. */}
      <Composer onSubmit={onSubmit} isAwaiting={isAwaiting} autoFocus />
    </Box>
  </Box>
);
